import SignatureItem from './signature-item';
import { SignaturesTypes } from './types';
import IconLoader from '../../icons/loader';

import styles from '../transaction.module.css';

export default function Signature({
  signatures,
  isLoadingSignatures,
}: SignaturesTypes) {
  let content;

  if (isLoadingSignatures) {
    content = (
      <div className={styles.contentLoader}>
        <IconLoader />
      </div>
    );
  } else if (signatures && (signatures?.length) > 0) {
    content = signatures.map((item) => (
      <SignatureItem key={item.id} signature={item} />
    ));
  } else {
    content = <div className={styles.emptyChangeLogs}>No signatures yet</div>;
  }

  return (
    <div className={styles.changeLogsWrapper}>
      <div className={styles.changeLogsTitle}>Signatures</div>
      {content}
    </div>
  );
}
